import React from 'react';
interface ChipGroupProps<T extends string> {
  label: string;
  value: T;
  onChange: (v: T) => void;
  options: Array<[T, string]>;
}
export function ChipGroup<T extends string>({
  label,
  value,
  onChange,
  options
}: ChipGroupProps<T>) {
  return <div role="radiogroup" aria-label={label} className="flex flex-wrap items-center gap-1.5" data-id="element-170" data-mp="2htxbbk26uhq9">
      <span className="mr-1 text-[13px] text-muted" data-id="element-171" data-mp="2ms73rmwj3486">{label}</span>
      {options.map(([v, l]) => <button key={v} type="button" role="radio" aria-checked={v === value} onClick={() => onChange(v)} className={`whitespace-nowrap rounded-full border px-2.5 py-1 text-[12.5px] transition-colors duration-150 ${v === value ? 'border-machine bg-machine/10 text-ink' : 'border-line text-muted hover:text-ink'}`} data-id="element-172" data-mp="2rnw9y931zjdg">
          {l}
        </button>)}
    </div>;
}